import type { PropsWithChildren } from "react";

import { Trophy } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon, Type } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const Favicon = ({ favicon }: { favicon?: string | null }) =>
    favicon ? (
        <ItemIcon
            iconType={Type.Website}
            iconSrc={favicon}
        />
    ) : null;

export const DomainCell = ({
    domain,
    favicon,
    children,
    fontVariant = "body2",
    showTrophy,
}: PropsWithChildren<{
    domain: string;
    favicon?: string | null;
    fontVariant?: "body2" | "subtitle2";
    showTrophy: boolean;
}>) => (
    <Flex
        alignItems="center"
        gap="8px"
    >
        <Favicon favicon={favicon} />
        <Text
            as="a"
            href={`https://${domain}`}
            target="_blank"
            rel="noopener noreferrer"
            fontVariant={fontVariant}
        >
            {children}
        </Text>
        {showTrophy ? (
            <Trophy
                size="xs"
                color={colorsPalettes.yellow[400]}
            />
        ) : null}
    </Flex>
);
